import { clearServiceDetails, getServiceNameFail, getServiceNameStarted, getServiceNameSuccess } from '../../../reducer/services/ServiceNameReducer';
import { getServiceType } from '../../actionType/services/ServiceActionTypes';

import {
  ClearService, GetServiceFailure, GetServiceFailurePayload, GetServiceRequest,
  GetServiceStarted,
  GetServiceSuccess,
  GetServiceSuccessPayload
} from '../../types/services/GetAllServiceType';

export const getServiceRequest = (serviceName: string, version: string): GetServiceRequest => ({
  type: getServiceType.FETCH_SERVICE_REQUEST,
  serviceName,
  version
});

/**
 * Fetch service started saga action
 * @returns service started action
 */
export const getServiceStarted = (): GetServiceStarted => ({
  type: getServiceNameStarted.type
});

/**
 * Fetch service success saga action
 * @param payload :Service data
 * @returns success action
 */
export const getServiceSuccess = (
  payload: GetServiceSuccessPayload
): GetServiceSuccess => ({
  type: getServiceNameSuccess.type,
  payload
});

/**
 * Fetch Service Faild saga action
 * @param payload : error message
 * @returns Failure saga action
 */
export const getServiceFailure = (
  payload: GetServiceFailurePayload
): GetServiceFailure => ({
  type: getServiceNameFail.type,
  payload
});

/**
 * Clear Service saga action
 */
export const clearService = (): ClearService => ({
  type: clearServiceDetails.type
});
